module.exports = __webpack_public_path__ + "img/horizontal_4_2_r_9016.95fd4f48.png";